import React from 'react';
import style from './style.scss';
import {Menu} from './menu.js';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {logout} from 'base/actions';
import {toastr} from 'react-redux-toastr';
import {UploadImage} from 'components/UI/Image';

class BusinessMenu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active: this.props.active
    };
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.dispatch(logout()).then(res => {
      toastr.success('Thành công', 'Bạn đã đăng xuất thành công');
      this.props.history.push('/');
    });
  }

  render() {
    const myBusinesses = this.props.myBusinesses.mainBusiness;
    return (
      <div className="my-business-wrap">
        {myBusinesses && <Link to={`/doanh-nghiep/${myBusinesses.nameSlug}`} className="my-business-detail">
          <div className="my-business-wrap-image">
            <UploadImage transform="crop" type="BUSINESS" width="30" height="30" image={myBusinesses.logo} />
          </div>
          <p className="my-business-name">{myBusinesses.name}</p>
        </Link> }
        {
          Menu.map((menuItem, i) => {
            let className="my-business-menu-item";
            if (menuItem.subMenu && menuItem.subMenu.length > 0) {
              className = className + " has-submenu";
            }

            if (this.state.active == menuItem.active) {
              className = className + " is-active";
            }

            return (
              <div className={className} key={i}>
                <Link className="my-business-menu-wrap-item" to={menuItem.link}><i className={menuItem.icon}/><span className="my-business-menu-content">{menuItem.name}</span></Link>
                {
                  menuItem.subMenu && menuItem.subMenu.length > 0 ? (
                    <div className="my-business-submenu">
                      <div className="my-business-submenu-shadow">
                        {
                          menuItem.subMenu.map((subMenu, j) => {
                            return (
                              <div className="my-business-submenu-item" key={j}>
                                <Link className="my-business-submenu-item-link" to={subMenu.link ? subMenu.link : ""}><span className="my-business-submenu-content">{subMenu.name}</span></Link>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  ) : null
                }
              </div>
            );
          })
        }
        <div className="my-business-logout">
          <p className="my-business-name" onClick={this.logout}>Đăng xuất</p>
        </div>
      </div>
    );
  }
}

BusinessMenu.defaultProps = {
  active: 'dashBoard'
};

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses
  };
};

export default withRouter(connect(mapStateToProps)(BusinessMenu));



// WEBPACK FOOTER //
// ./components/layouts/business/menu/BusinessMenu.jsx